import { useState } from "react";

import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";

/**
 * Formulário simples para cadastrar um novo destinatário de notificação
 * de Folha / V.A para um centro de custo específico.
 *
 * O backend revalida:
 *   - Permissão `rh.folha-pag.gerenciar-emails`;
 *   - CC presente no `user_access` do usuário;
 *   - Anti-duplicidade (mesmo par CC + e-mail).
 */
const ModalNewEmailFolha = ({ centrosCustoOpts = [], onCreated }) => {

    const { closeModal } = useModal();
    const api = useApi();

    const [centroCusto, setCentroCusto] = useState("");
    const [email, setEmail] = useState("");
    const [salvando, setSalvando] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!centroCusto) {
            alert("Selecione o centro de custo.");
            return;
        }

        if (!email) {
            alert("Informe o e-mail.");
            return;
        }

        try {

            setSalvando(true);

            const { data } = await api.post(
                "/Painel/API/FolhaPag/SaveEmail/",
                { centro_custo: centroCusto, email }
            );

            if (data?.status === "SUCCESS") {

                if (onCreated) await onCreated();
                closeModal();

            } else {

                alert(data?.message || "Não foi possível salvar o e-mail.");

            }

        } catch (err) {

            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao salvar e-mail.";
            alert(msg);

        } finally {

            setSalvando(false);

        }

    }

    return (
        <Overlay state={ true } >
            <Modal header close={ closeModal } size="sm" >
                <Formulario onSubmit={ handleSubmit } >
                    <FormComp
                        title="CENTRO DE CUSTO"
                        type="select"
                        options={ centrosCustoOpts }
                        valor={ centroCusto }
                        name="centro_custo"
                        changeFunc={ (e) => setCentroCusto(e.target.value) }
                        required
                    />
                    <FormComp
                        title="E-MAIL"
                        type="email"
                        valor={ email }
                        name="email"
                        placeholder="exemplo@palmont.com.br"
                        changeFunc={ (e) => setEmail(e.target.value.toLowerCase()) }
                        required
                    />
                    <FormComp
                        type="submit"
                        valor={ salvando ? "SALVANDO..." : "SALVAR" }
                        disabled={ salvando }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );

}

export default ModalNewEmailFolha;
